/* eslint-disable */
export default {
  loginButton: 'Iniciar sesión',
  signupButton: '¿Es un usuario nuevo? Regístrese',
  version: 'Versión',
} as const;

// @key: @#@"loginButton"@#@ @source: @#@"Sign In"@#@
// @key: @#@"signupButton"@#@ @source: @#@"New user? Sign Up"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
